// extracted by mini-css-extract-plugin
export default {"navbar":"Zr_Nvv"};